/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_it_all_started_with_frustration = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout a commencé par une <strong class="text-current">frustration que je partage avec beaucoup d’entrepreneurs</strong> : voir des idées brillantes échouer, non pas par manque de créativité, mais faute d’exécution technique adaptée aux moyens et contraintes réelles.`)
};

const en_it_all_started_with_frustration = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It all started with a <strong class="text-current">frustration that I share with many entrepreneurs</strong>: seeing brilliant ideas fail, not because of a lack of creativity, but because of a lack of technical execution adapted to the actual means and constraints.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const it_all_started_with_frustration = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.it_all_started_with_frustration(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("it_all_started_with_frustration", locale)
	if (locale === "fr") return fr_it_all_started_with_frustration(inputs)
	return en_it_all_started_with_frustration(inputs)
};